import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {TabButtonElement} from '../../../analytics/components/tabs/tabButtonElement';
import {useLinkNavigation} from '../../../components/common/navigation/useLinkNavigation';
import {buildSettingsDevelopersPath} from '../../../models/url/settingsUrlHelpers';
import {SettingsDevelopersPagesEnum, SettingsDevelopersUrl} from '../../../models/url/settingsUrlModel';

/*
 * Props.
 */

interface SettingsDevelopersHeaderTabsProps {
  url: SettingsDevelopersUrl;
}

/*
 * Component.
 */

export const SettingsDevelopersHeaderTabs: FC<SettingsDevelopersHeaderTabsProps> = (props) => {
  const {url} = props;
  const {navigateToLink} = useLinkNavigation();

  if (
    url.subPage === SettingsDevelopersPagesEnum.APPLICATIONS ||
    url.subPage === SettingsDevelopersPagesEnum.TOKENS
  ) {
    return (
      <>
        <TabButtonElement
          name={<Trans id="settings-developers-header-apps-tab">All apps</Trans>}
          isSelected={url.subPage === SettingsDevelopersPagesEnum.APPLICATIONS}
          onTabClick={() =>
            navigateToLink(
              buildSettingsDevelopersPath({
                rootPage: url.rootPage,
                subPage: SettingsDevelopersPagesEnum.APPLICATIONS,
              }),
            )
          }
        />
        <TabButtonElement
          name={<Trans id="settings-developers-header-tokens-tab">API Tokens</Trans>}
          isSelected={url.subPage === SettingsDevelopersPagesEnum.TOKENS}
          onTabClick={() =>
            navigateToLink(
              buildSettingsDevelopersPath({
                rootPage: url.rootPage,
                subPage: SettingsDevelopersPagesEnum.TOKENS,
              }),
            )
          }
        />
      </>
    );
  }
  return (
    <>
      <TabButtonElement
        name={<Trans id="settings-developers-header-info-tab">Basic information</Trans>}
        isSelected={url.subPage === SettingsDevelopersPagesEnum.APPLICATION_INFO}
        onTabClick={() =>
          navigateToLink(
            buildSettingsDevelopersPath({
              rootPage: url.rootPage,
              applicationId: url.applicationId,
              subPage: SettingsDevelopersPagesEnum.APPLICATION_INFO,
            }),
          )
        }
      />
      <TabButtonElement
        name={<Trans id="settings-developers-header-features-tab">Features</Trans>}
        isSelected={url.subPage === SettingsDevelopersPagesEnum.APPLICATION_FEATURES}
        onTabClick={() =>
          navigateToLink(
            buildSettingsDevelopersPath({
              rootPage: url.rootPage,
              applicationId: url.applicationId,
              subPage: SettingsDevelopersPagesEnum.APPLICATION_FEATURES,
            }),
          )
        }
      />
      <TabButtonElement
        name={<Trans id="settings-developers-header-oauth-tab">OAuth</Trans>}
        isSelected={url.subPage === SettingsDevelopersPagesEnum.APPLICATION_OAUTH}
        onTabClick={() =>
          navigateToLink(
            buildSettingsDevelopersPath({
              rootPage: url.rootPage,
              applicationId: url.applicationId,
              subPage: SettingsDevelopersPagesEnum.APPLICATION_OAUTH,
            }),
          )
        }
      />
      <TabButtonElement
        name={<Trans id="settings-developers-header-servers-tab">Servers</Trans>}
        isSelected={url.subPage === SettingsDevelopersPagesEnum.APPLICATION_SERVERS}
        onTabClick={() =>
          navigateToLink(
            buildSettingsDevelopersPath({
              rootPage: url.rootPage,
              applicationId: url.applicationId,
              subPage: SettingsDevelopersPagesEnum.APPLICATION_SERVERS,
            }),
          )
        }
      />
    </>
  );
};
